export default function formatNumbers(x) {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(x)) {
    return x;
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
